import { Translation } from '../contexts/TranslationContext'
import { InternalLink } from './Links'

export const menuItems = [
	{
		link: InternalLink.Wizard,
		label: <Translation tr="menuItems.wizard.title" />,
		name: 'Srovnávač na míru',
		paths: [InternalLink.Wizard],
		breadCrumbsTitle: <Translation tr="menuItems.breadCrumbs.wizard" />,
	},
	{
		link: InternalLink.Brands,
		paths: [
			InternalLink.Brand,
			InternalLink.ProductLine,
			InternalLink.Product,
			InternalLink.Brands,
			InternalLink.Results,
		],
		name: 'Značky a příchutě',
		label: <Translation tr="menuItems.brands.title" />,
	},
	{
		link: InternalLink.Ingredients,
		name: 'Složení granulí',
		paths: [InternalLink.Ingredient, InternalLink.IngredientCategory, InternalLink.Ingredients],
		label: <Translation tr="menuItems.items.title" />,
	},
	{
		link: InternalLink.BlogPosts,
		name: 'Rady a tipy',
		paths: [InternalLink.BlogPost, InternalLink.BlogPosts],
		label: <Translation tr="menuItems.blogPosts.title" />,
	},
	{
		link: InternalLink.Contact,
		paths: [InternalLink.Contact],
		name: 'Kontakt',
		label: <Translation tr="menuItems.contact.title" />,
	},
]
